import { UPDATE_IDENTIFY } from "./actionTypes";

const initialState = {
  identifyInfo: null, // geef aan wat voor data hier in zit. Ook handig voor code completion and zodat je meteen ziet wat voor data hier in kan zitten
  used_beukk: false,
  order_amount: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_IDENTIFY:
      return {
        ...state,
        identifyInfo: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
}
